// src/pages/bloomterminal/alerts/steps/AlertTypeSelector.jsx
import React from 'react';
import { useGlobalFontSize } from '../../../context/GlobalFontSizeContext';

const RadioButton = ({ checked, className = '' }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    {checked ? (
      <g>
        <circle cx="8" cy="8" r="4" fill="var(--bloom-green)" />
        <circle cx="8" cy="8" r="7.5" stroke="var(--bloom-green)" />
      </g>
    ) : (
      <circle cx="8" cy="8" r="7.5" stroke="var(--bloom-green)" />
    )}
  </svg>
);

const AlertTypeSelector = ({ selectedAlertType, onAlertTypeToggle }) => {
  const { fontSize } = useGlobalFontSize();
  const alertTypes = [
    { id: 'price', label: 'Price' },
    { id: 'volume', label: 'Volume' },
    { id: 'rain', label: 'Rain' },
    { id: 'temperature', label: 'Temperature' },
  ];

  return (
    <div className="flex flex-col gap-12 mt-14 flex-1 mx-auto">
      <div className="flex flex-col gap-[40px]">
        <div className="flex justify-center flex-wrap gap-[40px] items-center">
          {alertTypes.map((alertType) => (
            <button
              key={alertType.id}
              onClick={() => onAlertTypeToggle(alertType.id)}
              className="flex items-center gap-[8px] cursor-pointer"
            >
              <RadioButton checked={selectedAlertType === alertType.id} />
              <span 
                className="font-['Inter'] font-normal text-[#282A29] dark:text-[#f0f5f2]"
                style={{ fontSize: fontSize }}
              >
                {alertType.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlertTypeSelector;

